import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "text-xs text-gray-500 leading-none" }
const _hoisted_3 = { class: "flex items-center justify-between" }

import { configService } from '@/services/config/config.service';
// Composables
import usePoolTransfers from '@/composables/contextual/pool-transfers/usePoolTransfers';
import WithdrawForm from '@/components/forms/pool_actions/WithdrawForm/WithdrawForm.vue';
import TradeSettingsPopover, {
  TradeSettingsContext
} from '@/components/popovers/TradeSettingsPopover.vue';

/**
 * STATE
 */

export default _defineComponent({
  setup(__props) {

const { network } = configService;
const { pool, loadingPool, transfersAllowed } = usePoolTransfers();

return (_ctx: any,_cache: any) => {
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(loadingPool) || !_unref(transfersAllowed))
      ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
          key: 0,
          class: "h-96"
        }))
      : (_openBlock(), _createBlock(_component_BalCard, {
          key: 1,
          shadow: "xl",
          exposeOverflow: "",
          noBorder: ""
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(network).chainName), 1),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('withdrawFromPool')), 1),
                _createVNode(TradeSettingsPopover, {
                  context: _unref(TradeSettingsContext).invest
                }, null, 8, ["context"])
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(WithdrawForm, { pool: _unref(pool) }, null, 8, ["pool"])
          ]),
          _: 1
        }))
  ]))
}
}

})